import React from "react";
import { MemberShipCardUsageItem } from "../../../../../types/memberShipCardTypes";
import {
  getUsageAmount,
  getUsageTypeString,
} from "../../../../../libs/ourhome";

type Props = { item: MemberShipCardUsageItem };

export default function UsageItem({ item }: Props) {
  return (
    <div className="flex gap-2.5 px-5 h-[70px] items-center">
      <div className="flex-1 flex flex-col gap-1.5">
        <div className=" font-semibold leading-[19px]">{item.usedByName}</div>
        <div className="text-sm leading-[18px] text-brand-neutral-50">
          {item.usedAt}
        </div>
      </div>
      <div className="flex flex-col gap-1.5">
        <div className="font-semibold leading-[19px]">
          {getUsageAmount(item.usageType, item?.amount).toLocaleString()}원
        </div>
        <div className="text-sm leading-[18px] text-brand-neutral-50 text-right">
          {getUsageTypeString(item.usageType)}
        </div>
      </div>
    </div>
  );
}
